<!-- @format -->

<template>
	<pc-collapse :id="item.code" v-model="activeNames" class="collapse">
		<pc-collapse-item name="1" :title="item.pcProps.label">
			<template v-if="!item.children.length && status === 'widget'">
				<el-empty class="not-content" :image-size="50" description="请从左侧拖拽字段" />
			</template>
			<slot></slot>
		</pc-collapse-item>
	</pc-collapse>
</template>

<script setup lang="ts">
	import { Container } from '../../types';
	import { PcCollapse, PcCollapseItem } from '@/components';

	interface Props {
		item: Container;
		modelValue?: any;
	}
	const props = withDefaults(defineProps<Props>(), {});

	const status = inject('form-status', 'widget');

	const activeNames = ref(props.item.pcProps.defaultOpen ? ['1'] : []);
</script>

<style scoped lang="scss">
	.collapse {
		width: 100%;

		:deep(.el-collapse-item__content) {
			position: relative;

			.not-content {
				height: 100px;
				width: 100%;
				position: absolute;
			}

			.widget-form {
				min-height: 100px;
			}
		}
	}
</style>
